import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
const WOOD_TEXTURE_URL = 'https://cdn.magicpatterns.com/uploads/6XYuP79hZZpLpBNsdWWEYT/pexels-pixabay-326333.jpg';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen flex flex-col relative bg-[#1a1a1a]" data-id="element-58">
      {/* Premium Wood Design Edges - Desktop Only */}
      <div className="fixed inset-y-0 left-0 w-10 lg:w-20 xl:w-28 z-0 hidden lg:block overflow-hidden pointer-events-none border-r border-black/20 shadow-[inset_-10px_0_20px_rgba(0,0,0,0.3)]" style={{
      backgroundImage: `url(${WOOD_TEXTURE_URL})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-59">
        <div className="absolute inset-0 bg-black/10" data-id="element-60" />
      </div>

      <div className="fixed inset-y-0 right-0 w-10 lg:w-20 xl:w-28 z-0 hidden lg:block overflow-hidden pointer-events-none border-l border-black/20 shadow-[inset_10px_0_20px_rgba(0,0,0,0.3)]" style={{
      backgroundImage: `url(${WOOD_TEXTURE_URL})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-61">
        <div className="absolute inset-0 bg-black/10" data-id="element-62" />
      </div>

      {/* Main Content Wrapper */}
      <div className="relative flex flex-col min-h-screen z-10 mx-auto w-full lg:max-w-[calc(100vw-160px)] xl:max-w-[calc(100vw-224px)] bg-white shadow-[0_0_60px_rgba(0,0,0,0.6)]" data-id="element-63">
        <div className="sticky top-0 z-[100] w-full bg-white shadow-sm" data-id="element-64">
          <motion.div initial={false} animate={{
          height: isScrolled ? 0 : 'auto',
          opacity: isScrolled ? 0 : 1
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-65">
            <TopBar data-id="element-66" />
          </motion.div>
          <Navigation isScrolled={isScrolled} data-id="element-67" />
        </div>

        <div className="relative flex-grow" data-id="element-68">
          <AnimatePresence mode="wait" data-id="element-69">
            <motion.main key={location.pathname} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.4,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex-grow" data-id="element-70">
              {children}
            </motion.main>
          </AnimatePresence>
        </div>

        <Footer data-id="element-71" />
      </div>
    </div>;
}